import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import PostCardMeta from "components/PostCardMeta/PostCardMeta";
import { Link } from "react-router-dom";
import Badge from "../../shared/Badge/Badge";
import { BlogPost, BlogCategory } from "data/types";

export interface Card3Props {
  className?: string;
  post: BlogPost;
}

const Card3: FC<Card3Props> = ({ className = "h-full", post }) => {
  const { title, featuredImage, desc, categories } = post;

  return (
    <div
      className={`nc-Card3 relative flex flex-col-reverse sm:flex-row sm:items-center rounded-2xl group ${className}`}
      data-nc-id="Card3"
    >
      <div className="flex flex-col flex-grow">
        <div className="space-y-5 mb-4">
          {/*<CategoryBadgeList categories={categories} />*/}
          <div className="flex flex-wrap gap-2">
              {categories.length > 0 && (
                  categories.map((category: BlogCategory, index: number) => (
                      <Badge
                          key={index}
                          name={category.category}
                          /*href={item.href}*/
                          color={category.color}
                      />
                  ))
              )}
          </div>
          <div>
            <h2
              className={`nc-card-title block font-medium text-neutral-900 dark:text-neutral-100 text-xl`}
            >
              <Link to={`/blog-single/${post.id}`}
                    className="line-clamp-2"
                    title={title}>
                {title}
              </Link>
            </h2>
            <div className="hidden sm:block sm:mt-2">
              <span className="text-neutral-500 dark:text-neutral-400 text-base line-clamp-1">
                {desc}
              </span>
            </div>
          </div>

          <PostCardMeta meta={{ ...post }} />
        </div>
      </div>

      <div
        className={`block flex-shrink-0 sm:w-56 sm:ml-6 rounded-xl overflow-hidden mb-5 sm:mb-0`}
      >
        <Link
          to={`/blog-single/${post.id}`}
          className={`block w-full h-0 aspect-h-9 sm:aspect-h-16 aspect-w-16 `}
        >
          <NcImage
            containerClassName="absolute inset-0"
            src={featuredImage}
            alt={title}
          />
        </Link>
      </div>
    </div>
  );
};

export default Card3;
